import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "configurator-wrapper flex w-full relative"
};
import { useConfiguratorStore } from "@/stores/configurator";
import { useConfigurationStore } from "@/stores/configurationModule";
import { useWindowSize } from '@vueuse/core';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import { inject, onBeforeUnmount, watch, onMounted, ref, nextTick, computed } from "vue";
import { storeToRefs } from "pinia";
const DEFAULT_PREVIEW_WIDTH = 40;
export default {
  __name: 'ConfiguratorWrapper',
  setup(__props) {
    const {
      width: windowWidth
    } = useWindowSize();
    const $eventBus = inject('bus');
    const configurationStore = useConfigurationStore();
    const {
      boxType,
      boxDepth,
      boxLength,
      boxWidth
    } = storeToRefs(configurationStore);
    const configuratorStore = useConfiguratorStore();
    const {
      isEditorFullscreen,
      isPreviewFullscreen,
      mobileBreakpoint
    } = storeToRefs(configuratorStore);
    const splitpanesEditor2d = ref(null);
    const splitpanesBox3d = ref(null);
    const isMobileWidth = computed(() => windowWidth.value < mobileBreakpoint.value);
    const box3dWidth = ref(!isMobileWidth.value ? DEFAULT_PREVIEW_WIDTH : 100);
    const editor2dWidth = ref(100 - box3dWidth.value);
    const maxEditor2dWidth = ref(100);
    const minEditor2dWidth = ref(20);
    const splitpanesEl = ref(null);
    const showSaveCard = ref(false);
    function handleResize() {
      nextTick(() => {
        $eventBus.$emit("panes-resized");
      });
    }
    onMounted(() => {
      const splitter = splitpanesEl.value.container.querySelector('.splitpanes__splitter');
      splitter?.classList.add('bg-backgroundSplitter');
      splitter?.classList.add('border-borderSplitter');
      if (isMobileWidth.value) {
        // @NOTE: dirty hack to hide splitter on mobile to prevent it from being dragged.
        splitter?.style.setProperty('display', 'none');
      }
      handleResize();
      $eventBus.$on('screenshot-taken', () => {
        showSaveCard.value = true;
        setTimeout(() => {
          showSaveCard.value = false;
        }, 3000);
      });
      $eventBus.$on('close-configuration-saved-card', () => {
        showSaveCard.value = false;
      });
    });
    onBeforeUnmount(() => {
      $eventBus.$off('screenshot-taken');
      $eventBus.$off('close-configuration-saved-card');
    });
    watch(isEditorFullscreen, value => {
      box3dWidth.value = value ? 0 : DEFAULT_PREVIEW_WIDTH;
      editor2dWidth.value = 100 - box3dWidth.value;
      handleResize();
    });
    watch(isPreviewFullscreen, value => {
      box3dWidth.value = value ? 100 : DEFAULT_PREVIEW_WIDTH;
      editor2dWidth.value = 100 - box3dWidth.value;
      handleResize();
    });
    watch(windowWidth, value => {
      if (value <= mobileBreakpoint.value) {
        box3dWidth.value = 100;
        editor2dWidth.value = 0;
        minEditor2dWidth.value = 0;
        maxEditor2dWidth.value = 0;
      } else {
        box3dWidth.value = DEFAULT_PREVIEW_WIDTH;
        editor2dWidth.value = 100 - box3dWidth.value;
        minEditor2dWidth.value = 20;
        maxEditor2dWidth.value = 100;
      }
      handleResize();
    });
    return (_ctx, _cache) => {
      const _component_Editor2d = _resolveComponent("Editor2d");
      const _component_Preview3d = _resolveComponent("Preview3d");
      const _component_ConfigurationSavedCard = _resolveComponent("ConfigurationSavedCard");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Splitpanes), {
        ref_key: "splitpanesEl",
        ref: splitpanesEl,
        class: "w-full",
        onResize: handleResize,
        onReady: handleResize
      }, {
        default: _withCtx(() => [_createVNode(_unref(Pane), {
          ref_key: "splitpanesEditor2d",
          ref: splitpanesEditor2d,
          size: editor2dWidth.value,
          "max-size": maxEditor2dWidth.value,
          "min-size": minEditor2dWidth.value
        }, {
          default: _withCtx(() => [_unref(boxType) && _unref(boxWidth) && _unref(boxLength) && _unref(boxDepth) ? (_openBlock(), _createBlock(_component_Editor2d, {
            key: 0,
            type: _unref(boxType),
            width: _unref(boxWidth),
            length: _unref(boxLength),
            depth: _unref(boxDepth)
          }, null, 8, ["type", "width", "length", "depth"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["size", "max-size", "min-size"]), _createVNode(_unref(Pane), {
          ref_key: "splitpanesBox3d",
          ref: splitpanesBox3d,
          size: box3dWidth.value,
          "min-size": "20"
        }, {
          default: _withCtx(() => [_unref(boxType) && _unref(boxWidth) && _unref(boxLength) && _unref(boxDepth) ? (_openBlock(), _createBlock(_component_Preview3d, {
            key: 0,
            "is-editable": true,
            type: _unref(boxType),
            width: _unref(boxWidth),
            length: _unref(boxLength),
            depth: _unref(boxDepth)
          }, null, 8, ["type", "width", "length", "depth"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["size"])]),
        _: 1
      }, 512), _withDirectives(_createVNode(_component_ConfigurationSavedCard, {
        class: "absolute top-[64px] right-4 z-20"
      }, null, 512), [[_vShow, showSaveCard.value]])]);
    };
  }
};